module.exports = __webpack_public_path__ + "static/media/loading-icon.5cfc15c0.svg";